import { RouteStop, SearchResponse } from '@/api/types';

export default interface ExtendedMapOptions extends google.maps.MapOptions {
  useStaticMap?: boolean | null | undefined;
}

export interface MapViewBounds {
  north: number;
  east: number;
  south: number;
  west: number;
}

export interface MarkerInfoWindow {
  data: RouteStop | SearchResponse | null;
  type: MarkerType | null;
  deliveryRunReference: string | null;
  fleetNumber: string | null;
  routeStopIndex: number | null;
  position: google.maps.LatLngLiteral | null;
  open: boolean;
  options: MarkerInfoWindowOptions;
}

export interface MarkerInfoWindowOptions {
  minWidth: number;
  maxWidth: number;
  pixelOffset: MarkerInfoWindowOptionsOffSet;
}

export interface MarkerInfoWindowOptionsOffSet {
  width: number;
  height: number;
}

export enum MarkerType {
  trackable = 'Trackable',
  routeStop = 'RouteStop'
}
